// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectedSection_container__ooPUs"};